<template>
    <div class="table-students">
        <div class="back-route" @click.stop="router.go(-1)">
            <i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>
        <h2>{{ $t('course.tree.STUDENTSLOG') }}</h2>

        <p class="">En esta sección, puedes ver y agregar eventos para cada estudiante del curso.</p>

        <StudentsTable tableAt="studentsActivityLog" />
    </div>

</template>

<script>
import { onMounted } from 'vue-demi';
import StudentsTable from '@/components/StudentsTable.vue';
import { useRouter } from 'vue-router';


export default {
    components: {
    StudentsTable,
    },    
    setup() {
        const router = useRouter();


        onMounted(()=>{
        })

        return{
            router
        }

    },
}
</script>

<style lang="scss">
@import '@/styles/main.scss';

.table-students{
    .back-route{
        width: fit-content;
        display: flex;
        align-items: center;
        gap: 1px;
        font-weight: 600;
        font-size: 12px;
        color: $green;
        cursor: pointer;
        .material-icons{
            font-size: 17px;
        }
    }
    .content-container{
        font-size: 18px !important;
        *{
            font-size: 18px !important;
        }
    }
    p {
        font-size: 14px;
        font-weight: 400;
        padding: 24px 0;
    }
    h2{
        font-weight: 700;
        font-size: 22px;
        padding: 14px 0 6px 0;
        margin-bottom: 4px;
        color: $black;
        border-bottom: 1px solid rgba(125, 125, 125, 0.5);
    }
    
    #shareTRIPBtn{
        margin: 0 6px;
        padding: 2px 12px;
        background: $green;
        font-size: 14px;
        color: #fff;
        border-radius: 12px;
    }

    
    .tutor-download-excel{
        margin-top: 12px;
        margin-bottom: -12px;
        padding: 12px;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        gap: 16px;
        background-color: #F5F5F5;
        position: sticky;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: #fff;
        border-top: 2px solid #eee;
        z-index: 99;
        button{
            font-size: 16px;
            font-weight: 600;
            background: #009696;
            color: #fff;
            padding: 11px 25px;
            border-radius: 99px;
            &:disabled{
                opacity: .6;
                cursor: default;
            }
       }
    }

}

.finalPractice{
    display: flex;
    flex-direction: column;
    gap: 36px;
    &__welcome{
        display: flex;
        flex-direction: column;
        gap: 18px;
    }
    &__data{
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 16px;
        font-weight: 400;
        span{
            display: flex;
            align-items: center;
            gap: 8px;
            img{
                width: 48px;
                height: 48px;
            }
            strong{
                font-weight: 600;
            }   
        }
    }
    &__link{
        display: flex;
        align-items: center;
        gap: 24px;
        font-size: 16px;
        font-weight: 700;
    }
    &__linkButton{
        padding: 8px 29px;   
        color: $green;
        border: 1px solid $green;
        text-align: center;
        border-radius: 44px;
        font-weight: 600;
        font-size: 14px;
    }
    &__options{
        display: flex;
        align-items: center;
        gap: 24px;
        width: 100%;
    }
    &__card{
        border-radius: 10px;
        cursor: pointer;
        padding: 4px;
        width: 25%;
        height: 120px;
        transition: transform .2s ease;
        &:hover{
            transform: scale(1.03);
        }
        img{
            max-width: 285px;
            max-height: 120px;
            width: 200%;
            height: 200%;
            border-radius: 10px;
            object-fit: cover;
        }
        &--disabled{
            @extend .finalPractice__card;
            cursor: default;
            opacity: .6;
            &:hover{
                transform: none;
            }
        }
    }
    &__button{
        height: 45px;
        color: #fff;
        background-color: $green;
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 44px;
        width: fit-content;
        padding: 0 42px;
        .material-icons-outlined{
            font-size: 18px;
        }
    }
    &__modal{
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        padding: 0px 16px 16px;
        position: relative;
        &_iframe{

            &__disclaimer {
                font-size: 14px;
                margin-bottom: 16px;
            }
        }
        &_views{
            display: flex;
            align-items: center;
            width: 100%;
            border-bottom: 1px solid #e6e6e6;
            gap: 12px;
        }
        &_view{
            padding: 12px 8px;
            padding-bottom: 16px;
            font-size: 15px;
            font-weight: 500;
            color: #212121;
            &--active{
                padding: 12px 8px;
                font-size: 15px;
                font-weight: 500;
                color: $green;
                border-bottom: 5px solid $green;
                
            }
        }
        &__buttons{
            margin: 0 auto;
            display: flex;
            width: 100%;
            align-items: center;
            gap: 24px;
            justify-content: center;
        }
        &_button:first-child{
            color: $green;
            font-size: 16px;
            font-weight: 600;
        }
        &_button:last-child{
            font-size: 16px;
            font-weight: 600;
            background-color: $green;
            color: #fff;
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px 28px;
            border-radius: 44px;
            .material-icons-outlined{
                font-size: 18px;
            }
        }
    }
}

.confirmModal{
    width: 100%;
    padding: 34px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    text-align: center;
    &__title{
        font-weight: 600;
        font-size: 18px;
        strong{
            font-weight: 700;
            font-style: italic;
            color: $green;
        }
    }
    &__description{
        font-weight: 400;
        font-size: 18px;
    }
    &__buttons{
        display: flex;
        align-items: center;
        gap: 18px;
        width: 100%;
        justify-content: center;
        margin-top: 18px;
    }
    &__cancel{
        font-weight: 600;
        font-size: 16px;
        color: #212121;
    }
    &__confirm{
        color: #fff;
        background-color: $green;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
        padding: 10px 29px;
        border-radius: 44px;
        font-size: 16px;
    }
}
</style>